
import _ from "lodash"
import jsonStableStringify from "json-stable-stringify"

import { CHECKLIST_STEP_TYPES, MDB_TYPES } from "./constants.js"
import { ScenarioType, PublishedScenario } from "./types.js"

// the rest of these imports can go away soon. simply allows me to delete objects form the db
// and reload with files. not used if records exist in db
import INTVS from "./intvs.js"
import INTV_PROMPTS from "./intvPrompts.js"
import INTV_PROMPT_ANSWERS from "./intvPromptAnswers.js"
import INTV_MENU_CATS from "./intvMenusCats.js"
import INTV_MENU_ITEMS from "./intvMenuItems.js"

export{ MDB_TYPES , ANALYSIS_TYPES, CHECKLIST_STEP_TYPES, OPTION_TYPES, SELECTION_TYPES } from "./constants"
export { ScenarioType, PublishedScenario } from "./types"

export const loadIntvs = () => {
    const tmp = INTVS.map(e => {
        const rec = {...e}
        if (!e.abbrLabel) {
            rec.abbrLabel = e.label
        }
        if (!e.distPrompts) {
            rec.distPrompts = []
        }
        if (!e.prompts) {
            rec.prompts = []
        }
        return rec
    })
    return tmp
}

export const loadIntvPrompts = () => {
    const tmp = INTV_PROMPTS.map(e => {
        const rec = {...e}
        if (!!e.interventionID) {
            const found = INTVS.find(i => i.id === e.interventionID)
            if (!found) {
                console.log(`loadIntvPrompts(${e.id}) ${e.interventionID} not found`)
            }
        }
        if (!e.abbrLabel) {
            rec.abbrLabel = ""
        }
        if (!e.feedback) {
            rec.feedback = rec.label
        }
        if (!e.answers) {
            rec.answers = []
        }
        return rec
    })
    return tmp
}

export const loadIntvPromptAnswers = () => {
    const tmp = INTV_PROMPT_ANSWERS.map(e => {
        if (!e.abbrLabel) {
            e.abbrLabel = ""
        }
        const found = INTV_PROMPTS.find(p => p.id === e.promptID)
        if (!found) {
            console.log(`loadIntvPromptAnswers(${e.id}) ${e.promptID} not found`)
        }
        return e
    })
    return tmp
}

export const getScenarios = (db, scenarioType, schemaVersion) => {
    const query = db.collection("scenarios")
             .where("scenarioType", "==", scenarioType)
             .where("schemaVersion", "==", schemaVersion)
    return query.get()
        .then(snapShot => {
            const scenarios = []
            if (snapShot.size > 0) {
                snapShot.docs.forEach(doc => {
                    const data = doc.data()
                    scenarios.push({
                        id: data.id,
                        name: data.name,
                        scenarioType: data.scenarioType,
                        schemaVersion: data.schemaVersion
                    })
                })
            }
            return scenarios
        })
}

export const getPublishedScenarioObjectByID = async (db, scenarioID) => {
    const data = await getPublishedScenarioByID(db, scenarioID)
    return new  PublishedScenario(data)
}

export const getPublishedScenarioByID = (db, scenarioID) => {
    return db.collection("published-scenarios").doc(scenarioID).get().then(doc => doc.data())
}

export const getScenarioByID = (db, scenarioID) => {
    return db.collection("scenarios").doc(scenarioID).get().then(doc => doc.data())
}

export const getScenarioByName = (db, scenarioName, schemaVersion) => {
    return db.collection("scenarios")
    .where("name", "==", scenarioName)
    .where("schemaVersion", "==", schemaVersion)
    .limit(1)
    .get()
    .then(snapShot => {
        if (snapShot.size === 1) {
            return snapShot.docs[0].data()
        } else {
            throw new Error("document not found")
        }
    })
}

const addMissingScenarioTypeFields = (scenTypeData) => {
    const msgs = []
    if (scenTypeData.checklist) {
        // console.log(CHECKLIST_STEP_TYPES)
        scenTypeData.checklist.forEach(clItem => {
            if (! ("graded" in clItem)) {
                if (CHECKLIST_STEP_TYPES.includes(clItem.type)) {
                    clItem["graded"] = true
                    msgs.push(`set 'graded' to true for ${clItem.id}`)
                } else {
                    clItem["graded"] = false
                    msgs.push(`set 'graded' to false for ${clItem.id}`);
                }
            }
        })
    }
    if (!scenTypeData.interventions) {
        msgs.push("loading intvs from file")
        scenTypeData.interventions = loadIntvs()
    }
    if (!scenTypeData.interventionPrompts) {
        const errs = []
        const tmpPrompts = loadIntvPrompts()
        tmpPrompts.forEach(e => {
            if (e.type === MDB_TYPES.PROMPT) {
                // ignore this check if distinguishing prompt (not associated with a single intv)
                if (undefined === scenTypeData.interventions.find(rec => rec.id === e.interventionID)) {
                    errs.push(`bad interventionID ${e.interventionID}`)
                }
            }
        })
        let msg = "loading intv prompts from file..."
        if (errs.length > 0) {
            msgs.push(msg)
            errs.forEach(e => msgs.push(e))
        } else {
            msg += "no errors found"
            msgs.push(msg)
        }
        scenTypeData.interventionPrompts = tmpPrompts
    }
    if (!scenTypeData.interventionPromptAnswers) {
        const errs = []
        const tmpPromptAnswers = loadIntvPromptAnswers()
        tmpPromptAnswers.forEach(e => {
            if (undefined === scenTypeData.interventionPrompts.find(rec => rec.id === e.promptID)) {
                errs.push(`bad promptID ${e.promptID}`)
            }
        })
        let msg = "loading intv prompt answers from file..."
        if (errs.length > 0) {
            msgs.push(msg)
            errs.forEach(e => msgs.push(e))
        } else {
            msg += "no errors found"
            msgs.push(msg)
        }
        scenTypeData.interventionPromptAnswers = tmpPromptAnswers
    }
    if (!scenTypeData.interventionMenuCategories) {
        msgs.push("loading intv menu categories from file")
        scenTypeData.interventionMenuCategories = INTV_MENU_CATS
    }
    if (!scenTypeData.interventionMenuItems) {
        const errs = []
        const tmpIntvMenuItems = INTV_MENU_ITEMS.map(e => {
            const found = scenTypeData.interventionMenuCategories.find(cat => cat.id === e.intvCategoryID)
            if (!found) {
                errs.push(`bad intvCategoryID ${e.intvCategoryID}`)
            } else {
                if (e.type === MDB_TYPES.INTERV) {
                    const intv = scenTypeData.interventions.find(i => i.id === e.interventionID)
                    if (!intv) {
                        errs.push(`bad interventionID ${e.interventionID}`)
                    } else {
                        e.label = intv.label
                    }
                }
                return e
            }
        })
        let msg = "loading intv menu items from file..."

        if (errs.length > 0) {
            msgs.push(msg)
            errs.forEach(e => msgs.push(e))
        } else {
            msg += "no errors found"
            msgs.push(msg)
        }
        scenTypeData.interventionMenuItems = tmpIntvMenuItems
    }
    if (msgs.length > 0) {
        msgs.forEach(m => console.log(m))
    } else {
        console.log("all data loaded from db. files not needed")
    }
    return scenTypeData
}

export const getScenarioTypeObjectByID = async (db, scenarioTypeID) => {
    const data = await getScenarioTypeByID(db, scenarioTypeID)
    return new ScenarioType(data)
}

export const getScenarioTypeObject = async (db, scenarioType, schemaVersion) => {
    const data = await getScenarioType(db, scenarioType, schemaVersion)
    return new ScenarioType(data)
}

export const getScenarioTypeByID = (db, scenarioTypeID) => {
    return db.collection("scenario-types")
        .doc(scenarioTypeID)
        .get()
        .then(doc => {
        const data = doc.data()
        data.id = doc.id
        return addMissingScenarioTypeFields(data)
        })
        .catch(error => {
            console.log(error)
            return error
        })
}

export const getScenarioType = (db, scenarioType, schemaVersion) => {
    return db.collection("scenario-types")
            .where("name", "==", scenarioType)
            .where("schemaVersion", "==", schemaVersion)
            .limit(1)
            .get()
            .then(snapShot => {
                if (snapShot.size === 1) {
                    return addMissingScenarioTypeFields(snapShot.docs[0].data())
                } else {
                    throw new Error("document not found")
                }
            })
}



// FIXME: this needs to go away, although I need to figure out if it's in use anywhere first
export const getPromptAndOptions = (scenarioTypeOrPubScenario, promptID) => {
    const scenType = scenarioTypeOrPubScenario
    const prompt = scenType.interventionPrompts.find(e => e.id === promptID)
    if (!!prompt) {
        const options = prompt.answers.map(ansID => scenType.interventionPromptAnswers.find(a => a.id === ansID))
        prompt.options = options.map(opt => {
            return {...opt, prompt: prompt.label}
        })
    }
    return prompt
}

// moved over from apps/data-entry/src/scripts/connect-firebase
// added 'db' as first param so that these functions can be used either from web or server firebase APIs
/**
 * Verify document doesn't already exist in database.
 * @param {object} db instance
 * @param {string} collectionId
 * @param {string} documentId
 * @returns True if document with given ID doesn't exist yet.
 */
export const verifyDocument = async (db, collectionId, documentId) => {
    const set = await db.collection(collectionId).where("id", "==", `${documentId}`).get();
    return set.empty;
};

// returns true if combo of name and schemaVersion fields is unique
export const verifyDocNameUniqueness = async (db, collectionID, candidateName, dbNameField, schemaVersion) => {
    const snapshot = await db.collection(collectionID)
        .where(dbNameField, "==", candidateName)
        .where("schemaVersion", "==", schemaVersion)
        .get()
    return snapshot.empty
}

// Upload document object to database
export const publishDocument = async (db, collectionId, documentObject, documentId) => {
    documentId
        ?
        await db.collection(collectionId).doc(documentId).set(documentObject) :
        await db.collection(collectionId).doc().set(documentObject);
};

// Update document with given id
export const updateDocument = async (db, collectionId, documentId, documentObject) => {
    const set = await db.collection(collectionId).where("id", "==", `${documentId}`).get();
    set.empty ?
        publishDocument(collectionId, documentObject) :
        await db.collection(collectionId).doc(set.docs[0].id).set(documentObject);
};

/**
 * Will save document, using auto-generated IDs if documentObject doesn't have
 * an 'id' attribute.
 * @param {object} db instance
 * @param {string} collectionId
 * @param {object} documentObject
 */
export const saveDocument = async (db, collectionId, documentObject) => {
    const doc = (!documentObject.id) ?
        db.collection(collectionId).doc() :
        db.collection(collectionId).doc(documentObject.id);
    documentObject.id = doc.id;
    await doc.set(documentObject);
    return documentObject.id
}

/**
 * Query collection for document with id
 * @param {object} db instance
 * @param {string} collectionId
 * @param {string} documentId
 * @returns {object} Object containing document data.
 */
export const getDocument = async (db, collectionId, documentId) => {
    const doc = await db.collection(collectionId).doc(documentId).get();
    return doc.data();
};

/**
 * Query collection for document with name
 * @param {string} collectionId
 * @param {string} documentName
 * @returns {object} Object containing document data.
 */
export const getDocumentWithName = async (db, collectionId, documentName) => {
    const set = await db.collection(collectionId).where("name", "==", `${documentName}`).get();
    return set.docs[0]?.data();
};

/**
 * Delete document from collectio
 * @param {string} collectionId
 * @param {string} documentId
 */

 export const deleteDocument = async (db, collectionId, documentId) => {
    await db.collection(collectionId).doc(documentId).delete()}

export const deleteAndArchiveDocument = (db, collectionId, documentId) => {
    if (window.confirm ("Are you sure you want to delete this file?  It will be archived but you will need help to retrieve it."))
        {const data = getDocument(db, collectionId, documentId)
         let archiveId = "archive-" + collectionId
         saveDocument (db, archiveId, data)
         deleteDocument (db, collectionId, documentId)
    }
}

export const deleteDocumentNoArchive = async (db, collectionId, documentId) => {
    if (window.confirm ("Are you sure you want to delete this file?"))
        {await db.collection(collectionId).doc(documentId).delete()};
};

export const deleteObsAndAnaDocuments = (db, id) => {
    deleteAndArchiveDocument(db,"logs",id)
    //deleteDocument(db,"debriefing-feedback-logs",id)
}

export const deleteObsDocument = (db, id) => {
    deleteAndArchiveDocument(db,"logs",id)
}

export const deleteAnaDocument = (db, id) => {
    deleteDocument(db,"analyzed-logs",id)
}

export const deleteCond1CommentDocument = (db, id) => {
    deleteDocument(db,"cond1-comments",id)
}

export const deleteCommentDocument = (db, id) => {
    deleteAndArchiveDocument(db,"debriefing-comment-logs",id)
}

/**
 * Pull collection from database as array of document objects
 * @param {string} collectionId
 * @returns {object[]} An array containing all of the document in the collection.
 */
export const getCollection = async (db, collectionId) => {
    const collection = await db.collection(collectionId).get();
    return collection.docs?.map(item => item.data());
};

// copied over from /apps/debriefer/src/scripts/connect-firebase and 'db' param added as first param

// Get a list of document names and a copy of each document
export const listDocumentNames = async (db, collectionId) => {
    let documentList = db.collectionGroup(collectionId);
    let documentDictionary = {};
    documentList.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            documentDictionary[doc.id] = doc.data();
        });
    });
    return documentDictionary;
}

function exportObserverLogMetaData(doc) {
    const data = doc.data()
    return {
      id: doc.id,
      label: data.label,
      scenario: data.scenarioName,
      scenarioID: data.scenarioID,
      userName: data.userName,
      timestamp: data.timestamp,
      classCode: data.classCode,
      condition: data.condition,
    };
}

export const getLogs = (db) => {
    return db.collection("logs").get()
        .then(querySnapshot => querySnapshot.docs.map(doc => exportObserverLogMetaData(doc)))
        .catch(error => {
            console.error(error)
            return []
        })
}

export const getObserverLogAnalyses = (db, observerLogID) => {
    return db.collection("analyzed-logs")
            .where("observerLogID", "==", observerLogID)
            .get()
            .then(querySnapShot => {
                return querySnapShot.docs.map(doc => {
                    const data = doc.data()
                    return {
                        id: doc.id,
                        label: data.label,
                        observerLogID: data.observerLogID,
                        analyzer: data.analyzer,
                        timestamp: data.timestamp
                    }
                })
            })
            .catch(error => {
                console.error(error)
                return []
            })
}

const getPublishedScenarios = (logs, pubScens, pubScenIDs, onlyPublished) => {
    let filtered = []
        for (let log of logs){
        if (pubScenIDs.includes(log.scenarioID)){
            let version = pubScens.find(s => s.id === log.scenarioID).version
            log.publishedVersion = version
            filtered.push(log)
        }
    } 
    if (onlyPublished){
        return filtered.sort((a,b) => a.publishedVersion.localeCompare(b.publishedVersion))}
    else {return logs.sort((a,b) => a.publishedVersion.localeCompare(b.publishedVersion))}
}


export const getObserverLogList = async (db, onlyPublished=true) => {
    // by default, only lists observer logs which don't refer to currently 
    // published scenarioIDs
    const pubScens = await getPubScenarios(db)
    const pubScenIDs = pubScens.map(e => e.id)
    return db.collection("logs")
        .get()
        .then(querySnapshot => querySnapshot.docs.map(doc => exportObserverLogMetaData(doc)))
        .then(logs => 
            (getPublishedScenarios(logs,pubScens,pubScenIDs,onlyPublished))
        )
        .catch(error => {
            console.error(error)
            return []
        })
}


export const getPubScenarios = (db) => {
    let results = []
    return db.collection("published-scenarios").get()
        .then(querySnapshot => {
            return querySnapshot.docs.map(doc => {
                const data = doc.data()
                return {id: doc.id,
                        version: data.version}
            })
        })
}

export const createCond1Comments = async (db, analysis, userName) => {
    const docRef = await db.collection("cond1-comments").doc()
    const id = docRef.id
    const data = {
        id,
        comments: Array(analysis.events.length).fill(""),
        scenarioName: analysis.scenarioName,
        classCode: analysis.classCode || "",
        condition: analysis.condition || "",
        label: analysis.label || null,
        reviewer: userName,
        id: id,
        analysisLogID: analysis.id,
        observerLogID: analysis.observerLogID,
        scenarioID: analysis.scenarioID || "", 
        timestamp: Date()
    }
    await docRef.set(data)
    return id
}

export const createCond2Debriefing = async (db, analysis, userName) => {
    const docRef = await db.collection("cond2-debriefings").doc()
    const id = docRef.id
    const data = {
        id,
        analysisLogID: analysis.id,
        observerLogID: analysis.observerLogID,
        reviewer: userName,
        comments: {},
        timestamp: Date()
    }
    await docRef.set(data)
    return id
}
export const getAnalysisCond1Comments = (db, analysisLogID) => {
    return db.collection("cond1-comments")
            .where("analysisLogID", "==", analysisLogID)
            .get()
            .then(querySnapshot => {
                return querySnapshot.docs.map(doc => {
                    const data = doc.data()
                    return {
                        id: doc.id,
                        ...data
                    }
                })
            })
}

export const getAnalysisCond2Debriefings = (db, analysisLogID) => {
    return db.collection("cond2-debriefings")
    .where("analysisLogID", "==", analysisLogID)
    .get()
    .then(querySnapshot => {
        return querySnapshot.docs.map(doc => {
            const data = doc.data()
            return {
                id: doc.id,
                ...data
            }
        })
    })
}

export const getDebriefCommentLogs = (db) => {
    return db.collection("debriefing-comment-logs").get()
        .then(querySnapshot => {
            return querySnapshot.docs.map(doc => {
                const data = doc.data()
                return {
                    id: doc.id,
                    label: data.label,
                    scenario: data.scenarioName,
                    scenarioID: data.scenarioID,
                    commenter: data.commenter,
                    timestamp: data.timestamp
                }
            })
        })
}

export const getAnalyses = (db) => {
    return db.collection("analyzed-logs").get()
        .then(querySnapshot => {
            return querySnapshot.docs.map(doc => {
                const data = doc.data()
                return {
                    id: doc.id,
                    label: data.label,
                    observerLogID: data.observerLogID,
                    analyzer: data.analyzer,
                    timestamp: data.timestamp
                }
            })
        })
}

export const getCond1CommentLogs =  (db) => {
    return db.collection("cond1-comments").get()
        .then(querySnapshot => {
            return querySnapshot.docs.map(doc => {
                const data = doc.data()
                return {
                    id: doc.id,
                    label: data.label,
                    analysisLogID: data.analysisLogID,
                    commenter: data.commenter,
                    timestamp: data.timestamp
                }
            })
        })
}

export const getLog = (db, logID) => {
    return db.collection("logs").doc(logID).get()
        .then((doc) => {
            const data = doc.data()
            if (!!data){
                data.id = doc.id
                return data}
            else {return null}
        })
        .catch(error => {
            console.error(error)
            return null
        })
}

export const getDebriefLog = (db, logID) => {
    return db.collection("debriefing-feedback-logs").doc(logID).get()
        .then((doc) => {
            const data = doc.data()
            if (!!data){
                data.id = doc.id
                return data}
            else {return null}
        })
        .catch(error => {
            console.error(error)
            return null
        })
}

export const getDebriefCommentLog =  (db, logID) => {
    return db.collection("debriefing-comment-logs").doc(logID).get()
        .then((doc) => {
            const data = doc.data()
            if (!!data){
                data.id = doc.id
                return data}
            else {return false}
        })
        .catch(error => {
            console.error(error)
            return null
        })
}



export const getAnalysisLog = (db, logID) => {
    return db.collection("analyzed-logs").doc(logID).get()
        .then((doc) => {
            const data = doc.data()
            if (!!data){
                //data.id = doc.id
                return data
            }
            else {return null}
        })
        .catch(error => {
            console.error(error)
            return null
        })
}

export const getCond1CommentLog =  (db, logID) => {
    return db.collection("cond1-comments").doc(logID).get()
        .then((doc) => {
            const data = doc.data()
            if (!!data){
                data.id = doc.id
                return data}
            else {return null}
        })
        .catch(error => {
            console.error(error)
            return null
        })
}

export const getCond2DebriefingLog = (db, debriefingID) => {
    return db.collection("cond2-debriefings").doc(debriefingID).get()
        .then((doc => {
            const data = doc.data()
            return {
                id: doc.id,
                ...data
            }
        }))
}

export const getObserverLog = (db, logID) => {
    return db.collection("logs").doc(logID).get()
        .then((doc) => {
            const data = doc.data()
            if (!!data){
                data.id = doc.id
                return data}
            else {return null}
        })
        .catch(error => {
            console.error(error)
            return null
        })
}


export const getDebriefLogWithName = async (db, documentName) => {
    const set = await db.collection("debriefing-feedback-logs").where("ObserverFileName", "==", `${documentName}`).get();
    return set.docs[0]?.data();
};

export const createInterventionVariant = (distPromptIds2OptIds) => {
    // the list of opt IDs mapped to each distPromptID needs to be sorted in order
    // to make them comparable
    const retVal = {}
    Object.entries(distPromptIds2OptIds).forEach(([distPromptID, optionsArray]) => {
        retVal[distPromptID] = optionsArray.sort()
    })
    return retVal
}

export const interventionVariantsAreEqual = (intvVariant1, intvVariant2) => {
    return _.isEqual(intvVariant1, intvVariant2)
}


export const intvVariant2JSON = (intvVariant) => {
    return jsonStableStringify(intvVariant)
}